import { put, take, race, call, fork, takeLatest } from "redux-saga/effects";
import * as Store from './registerUserStore'
import { push } from "react-router-redux";
import { RegisterUserModel } from "./RegisterUserModels";
import { registerUser } from "../../api/accountApi";
import * as companyApi from '../../api/companyApi'
import { actions } from 'react-redux-form';
import { actions as rrfActions } from 'react-redux-form';
import * as Notifications from '../../notifications/notificationsStore'

export function* watchRegisterUserSagas() {
    yield takeLatest(Store.ActionType.RegisterUserRequest, registerUserFlow);
}

export function* registerUserFlow(action: Store.RegisterUserRequestAction) {
    yield registerWithIdentifier(action.identifier);
}

function* registrationFailed() {
    yield put(Notifications.actionCreators.addNotification({ id: "registrationFailed", message: "Käyttäjän rekisteröinnissä tapahtui virhe.", variant: "error", autohide: true  }));
}

function* registerWithIdentifier(identifier: string) {
    const companyEntity = yield call(companyApi.findCompanyWithRegistrationId, identifier);
    yield put(actions.change("registerUserModel.company", companyEntity.name));

    yield put(push("/register/user/" + identifier));

    const winner = yield race({
        submit: take(Store.ActionType.RegisterUserSubmitted),
        cancel: take(Store.ActionType.RegisterUserCancelled)
    });

    if (winner.submit) {
        // Register form filled and submitted                        
        const userData: RegisterUserModel = winner.submit.data;

        const registrationSuccess = yield call(registerUser, identifier, userData);

        // Registration finished
        if (registrationSuccess) {
            yield put(Store.actionCreators.registerUserSuccess());
            yield put(rrfActions.reset("registrationPrompt"))

            // Wait for input to continue to login
            yield take(Store.ActionType.RegisterUserContinueToLogin);
            yield put(push("/login"));
            yield put(actions.reset("registerUserModel"));
        }
        else {
            yield fork(registrationFailed);

        }
    }
}



// WEBPACK FOOTER //
// ./src/register/user/registerUserSagas.ts